import { render } from "./ModalDevicesList.vue?vue&type=template&id=04678060"
import script from "./ModalDevicesList.vue?vue&type=script&lang=js"
export * from "./ModalDevicesList.vue?vue&type=script&lang=js"
/* custom blocks */
import block0 from "./ModalDevicesList.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__